module.exports = __webpack_public_path__ + "static/img/login_bg.2060c85.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_bg.png
// module id = /FpT
// module chunks = 1